import styled from "styled-components";

export const PanelHeader = styled.div`
  background: #3d434c;
  border-bottom: 1px solid #4e5866;
  width: 100%;
  min-height: 42px;
  color: #fff;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 700;
  line-height: 19.07px;
  text-align: left;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
`;

export const PanelHelp = styled.a`
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  line-height: 16.34px;
  letter-spacing: 1px;
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
`;

export const UploadButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px;
  margin-bottom: 8px;

  & button {
    height: 57px;
    width: 100%;
    margin-left: 0;
    display: flex;
    flex-direction: row-reverse;

    &:first-child {
      margin-right: 16px;
    }
  }
`;

interface PanelTextProps {
  align?:
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "baseline"
    | "stretch";
  justify?:
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "baseline"
    | "stretch";
  height?: string;
  paddingBottom?: number;
}

export const PanelContent = styled.div<PanelTextProps>`
  color: #fff;
  padding: ${(props: PanelTextProps) =>
    props.paddingBottom ? `16px 16px ${props.paddingBottom}px` : "16px 16px 0"};
  height: ${(props: PanelTextProps) =>
    props.height ? `${props.height}` : "198px"};
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  text-align: ${(props: PanelTextProps) => props.align || "center"};
  display: flex;
  align-items: ${(props: PanelTextProps) => props.align || "center"};
  flex-direction: column;
  justify-content: ${(props: PanelTextProps) => props.justify || "center"};
  box-sizing: border-box;

  & p {
    margin-top: 0;
  }

  & .final-status-logo {
    margin-bottom: 16px;
    height: 36px;
    width: 36px;
  }

  & .file-picker-input {
    width: 100%;

    & > button {
      height: 32px;
    }
  }
`;

export const ActivateButtonWrapper = styled.div`
  padding: 0 16px;
  margin-top: auto;
  margin-bottom: 24px;

  & button {
    width: 100%;
    margin-top: 4px;
    display: flex;

    &.shift-icon-right {
      flex-direction: row-reverse;
    }
  }
`;

export const InvalidFile = styled.div`
  display: flex;

  & > div {
    margin-right: 8px;
  }
`;
